import { render, staticRenderFns } from "./DisplaySetsNumber.vue?vue&type=template&id=849d0b1e&scoped=true&"
import script from "./DisplaySetsNumber.vue?vue&type=script&lang=js&"
export * from "./DisplaySetsNumber.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySetsNumber.vue?vue&type=style&index=0&id=849d0b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d0b1e",
  null
  
)

export default component.exports